<template>
    <b-form-group id="example-input-group-1" label="Tags" label-for="example-input-1">
        <div class="tags-input-container">
            <input v-model="tagValue" @keyup.enter="addTag">

            <!-- <b-form-input placeholder="Type tag here" id="example-input-1" name="example-input-1" v-model="tagValue"
                @keyup.enter="addTag" aria-describedby="input-1-live-feedback"></b-form-input> -->

<!-- <vue-taggable-select
    make-it-taggable="good!"
    :taggable="true"
    v-model="tagValue"
    :options="tags_array"
></vue-taggable-select> -->

<!-- :required="true" -->

            <!-- multi tag work start-->
            <!-- <p class="mb-2">Choose Tags from default tags</p>
            <div class="tag_box mb-0 mt-0">
                <span v-for="(tag,index) in allTags" :key="'tag'+index">
                    <span :style="(tag.selected) ? 'background:#3bccb0;color:#fff' : ''" @click="tagSelect(tag)">{{
                    tag.tag
                    }}</span>
                </span>
            </div> -->
            <!-- multi tag work end-->

            <b v-if="tags.length > 0">Selected Tags :</b>
            <div class="selected-tags-box">
                
                <div class="tag" v-if="typeof tags == 'string'">
                    <span v-if="activeTag !== index" @click="activeTag = index">{{ tags }}</span>
                    <input v-else v-model="tags" v-focus :style="{'width': 1 + 'ch'}"
                        @keyup.enter="activeTag = null" @blur="activeTag = null" />

                    <span @click="removeTag(index,tags)"><i class="mdi mdi-close-circle-outline"></i></span>
                </div>
                
                <div class="tag" v-else v-for="(tag, index) in tags" :key="'tag'+index">
                    <span v-if="activeTag !== index" @click="activeTag = index">{{ tag }}</span>
                    <input v-else v-model="tags[index]" v-focus :style="{'width': tag.length + 'ch'}"
                        @keyup.enter="activeTag = null" @blur="activeTag = null" />
                    <span @click="removeTag(index,tag)"><i class="mdi mdi-close-circle-outline"></i></span>
                </div>
            </div>
        </div>
    </b-form-group>
</template>

<script>
import api from "../config/api";
export default {
    name: "Tag",
    // props: ['oldtags'],
    data() {
        return {
            allTags: [],
            tags_array : [],
            tags: [],
            tagValue: '',
            activeTag: null,
            oldtags: "",
        }
    },

    // watch for auto suggest tag work
    // watch:{
    //     tagValue(newVal){
    //         this.addTag();
    //     },
    // },

    mounted() {
        // this.fetchOldTags()
        // if(this.oldtags != ""){
        this.allTagsFunc();
        // }
        if (this.oldtags != "")
            if (typeof (this.oldtags) == 'string') {
                this.tags = JSON.parse(this.oldtags);
            } else {
                this.tags = this.oldtags;
            }
    },
    methods: {
        async allTagsFunc() {
            try {
                let data = await this.$store.getters['getEditFormData'];
                
                if (data.length == 0) {
                    console.log('data lenght == 0')
                    data = localStorage.getItem('data_for_edit');
                    data = JSON.parse(data);
                    console.log("data from tag compo ::::: if 1")
                }
                // typeof data?.tag != "undefined"
                if (data?.tag != null) {
                    this.oldtags = data?.tag
                    if(typeof data?.tag == "string"){
                        this.tags.push(data?.tag)
                    }
                    else{
                        this.tags = data?.tag;
                    }
                }

                // if(data?.tag != null){
                //         console.log("data from tag compo ::::: if 2" , data?.tag)
                //     }
                    let result = await api.get(`/admin/all-tags`);
                    let tags = result.data.all_tags;

                    // let result2 = await api.get(`/admin/tags`);
                    // console.log("all tags ::::::: "  ,result2.data.tags);
                    // this.tags_array = result2.data.tags;
                    // console.log("all tags ::::::: "  , this.tags_array);
                    tags.forEach(object => {
                        // this.tags_array.push(object.tag);
                        if (this.oldtags != "") {
                            if (this.oldtags.includes(object.tag)) {
                                object.selected = true;
                            }
                            else{
                                this.tags_array.push(object.tag);
                            }
                        } else {
                            this.tags_array.push(object.tag);
                            object.selected = false;
                        }
                    });
                    tags = tags.filter(x => x.status == 'Active');
                    this.allTags = tags;
                // }
            } catch (error) {
                this.error = error.response.data.message;
                this.$toast.error(this.error);
            }
        },
        addTag() {
            if (!this.tagValue == '' || this.tagValue != null)
                console.log("from add tag old inner :::: " , this.tagValue[this.tagValue.length - 1]);
                // if (this.tagValue[this.tagValue.length - 1].indexOf(',') > -1) {
                //     const arr = this.tagValue[this.tagValue.length - 1].split(',');
                //     this.tags = [...this.tags, ...arr];
                // }
                // console.log("from add tag old :::: " , this.tags);
                // let full_tags_arr = this.tags.concat(this.tagValue);
                // this.$emit('updateTag', full_tags_arr);


                if (this.tagValue.indexOf(',') > -1) {
                    console.log('under if');
                    const arr = this.tagValue.split(',');
                    this.tags = [...this.tags, ...arr];
                    this.$emit('updateTag', this.tags);
                } else {
                    console.log('under else' , this.tags);
                    this.tags.push(this.tagValue);
                    if(this.tags.length > 1){
                        this.$emit('updateTag', this.tags);    
                    }else{
                        this.$emit('updateTag', this.tagValue);
                    }
                }
            this.tagValue = '';
        },
        tagSelect(tags) {
            this.allTags.map((tg) => {
                if (tg.id == tags.id) {
                    tg.selected = !tg.selected
                }
                return tg;
            })

            if (!this.tags.includes(tags.tag)) {
                this.tags.push(tags.tag);
            } else {
                this.tags = this.tags.filter(x => x != tags.tag);
            }
            this.$emit('updateTag', this.tags);
        },
        tagSelectForUpdate(tags) {
            this.allTags.map((tg) => {
                if (tg.id == tags.id) {
                    tg.selected = !tg.selected
                }
                return tg;
            })

            if (!this.tags.includes(tags.tag)) {
                this.tags.push(tags.tag);
            } else {
                this.tags = this.tags.filter(x => x != tags.tag);
            }
            this.$emit('updateTag', this.tags);
        },
        removeTag(index, tag) {
            if(!this.tags_array.includes(tag))
                this.tags_array.push(tag);
            this.allTags.map((tg) => {
                if (tg.tag == tag) {
                    tg.selected = false
                }
                return tg;
            })
            this.tags.splice(index, 1);
            this.$emit('updateTag', this.tags);
        },

    }
}
</script>

<style scoped>
/* multi tags work start */
.tag_box {
    background: #fff;
    border: solid 1px #dadada;
    border-radius: 8px;
    padding: 8px;
    color: #333;
    outline: none;
    width: 100%;
    height: 150px;
    overflow-y: auto;
    margin: 15px 0;
    word-break: break-word;
}

.tags-input-container>input {
    background: #fff;
    border: solid 1px #dadada;
    border-radius: 8px;
    padding: 8px 16px;
    color: #333;
    outline: none;
    width: 100%;
    margin: 15px 0;
}


.tag_box span {
    display: inline-block;
}

.tag_box span span {
    border: 1px solid #D3D3D3;
    padding: 4px 10px;
    border-radius: 9px;
    margin: 10px 2px;
    cursor: pointer;
    margin-top: 5px;
    margin-bottom: 5px;
    color: #808080;
}

.tag {
    display: inline-block;
    padding: 10px 15px;
}

.selected-tags-box {
    /* border:1px solid black; */
    max-height: 100px;
    overflow-y: scroll;
}

/* multi tags work end */
</style>